import React from "react";
import {useTranslation} from "react-i18next";
import {Navigate} from "react-router-dom";

import Page from "../../elements/Page/Page";
import CommissionsBox from "./CommissionsBox";

import {isLoggedIn} from "../../utils/utils";
import ClicksBox from "./ClicksBox";

const StatisticsPage = () => {

  const { t } = useTranslation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace={true} />
  }

  return (
    <Page headline={t("StatisticsPage.Headline")}>
      <ClicksBox />
      <CommissionsBox />
    </Page>
  );
}

export default StatisticsPage;